const module = { name: 'concessions/concessionsOfferCarousel', exports: {} }; const exports = module.exports;



import { default as $ } from 'swug-fdRequire-call:jQuery';



import { Fandango_debugLog as debugLog } from 'require-core';



import { Fandango_carousel as fdCarousel } from 'require-global';



import { Fandango as Fandango_context } from 'require-core';

const { context: { device: { isMobile } } } = Fandango_context;


import { default as Fandango_triggerEvent_triggerAnalyticsEvent } from 'swug-fdRequire-call:Fandango/triggerEvent';

const { triggerAnalyticsEvent } = Fandango_triggerEvent_triggerAnalyticsEvent;


const HIDE_CLASS = 'hide'


const OFFERS_CAROUSEL_ID = 'offers-carousel'


const OFFERS_CAROUSEL_WRAPPER = `#${OFFERS_CAROUSEL_ID}`


const CAROUSEL_NAME = 'Concessions Offer Carousel'
function getActiveSlideIndex(rootEl) {
    const root = rootEl instanceof HTMLElement ? rootEl : rootEl?.[0];
    const activeSlide = root?.querySelector('.splide__slide.is-active');
    const activeCta = activeSlide?.querySelector('[data-slide-index]');
    const idx = Number(activeCta?.getAttribute('data-slide-index'));
    return Number.isFinite(idx) ? idx : 1;
}
function getActiveOfferSlideInfo(rootEl) {
    const root = rootEl instanceof HTMLElement ? rootEl : rootEl?.[0];
    if (!root) {
        return { slideIndex: 1, sectionHeader: '' };
    }
    const slideIndex = getActiveSlideIndex(root);
    const activeSlide = root.querySelector('.splide__slide.is-active');
    const headerEl = activeSlide?.querySelector('.carousel-header');
    const sectionHeader = headerEl?.textContent?.trim() || '';
    return { slideIndex, sectionHeader };
}
function bindSwipeAnalyticsEvent(instance) {
    instance.on('moved', (newIndex, oldIndex) => {
        if (!Number.isFinite(newIndex)) {
            return;
        }
        if (newIndex === oldIndex) {
            return;
        }
        const { slideIndex, sectionHeader } = getActiveOfferSlideInfo(instance.root);
        triggerAnalyticsEvent('concessions carousel swipe (mobile)', {
            carouselName: CAROUSEL_NAME,
            carouselTilePosition: String(slideIndex),
            contentTitle: sectionHeader,
            pageName: 'concessions | how it works',
            pageType: 'concessions landing',
            event: 'concessions carousel swipe (mobile)',
        });
    });
}
function init() {
    debugLog.log(module.name, 'init');
    const $container = $(OFFERS_CAROUSEL_WRAPPER);
    if (!$container.length) {
        debugLog.warn(module.name, 'Carousel container not found:', OFFERS_CAROUSEL_WRAPPER);
        return;
    }
    $container.removeClass(HIDE_CLASS);
    const carouselOpts = {
        gap: 0,
        padding: { left: 0, right: 0 },
        pagination: true,
        perPage: 1,
        type: 'loop',
    };
    fdCarousel.init(OFFERS_CAROUSEL_ID, carouselOpts);
    const offersInstance = fdCarousel.getInstance(OFFERS_CAROUSEL_ID);
    if (!offersInstance) {
        debugLog.warn(module.name, 'Splide instance not available for:', OFFERS_CAROUSEL_ID);
        return;
    }
    if (isMobile) {
        bindSwipeAnalyticsEvent(offersInstance);
    }
}
module.exports = {
    init,
};
export default module.exports;